module.exports = __webpack_public_path__ + "assets/img/theX-content-1.35c9ee1f.png";